import axios from 'axios-instance';
import Cookies from 'js-cookie';
import {
  SEAWARE_TEST_COOKIE_NAME,
  SEAWARE_TEST_COOKIE_VALUE,
} from './constants';

export const checkUserExistsInSeaware = async (): Promise<boolean> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}Seaware/CheckUserIsExisting`
    );

    const { data } = response;

    return Boolean((data as { userExists?: boolean }).userExists);
  } catch (_error) {
    return false;
  }
};

export const isSeawareCheckEnabled = (): boolean => {
  const cookie = Cookies.get(SEAWARE_TEST_COOKIE_NAME);
  return cookie === SEAWARE_TEST_COOKIE_VALUE;
};
